import React, { useEffect, useState } from 'react'
import { HoraActual,  fechaActual } from '../../../hooks/UseDate'
import { postCambioDeEstadoCanceladoUpdateHCCOM51,  postCancelarCirugia, postEstadoCanceladoUpdateHCCOM5 } from '../../../services/PaginaRuta'

const ConfirmarEstadoCancelacion = ({setmodalOnCancelarCirugia,user, passDataActualizarTabla}) => {
    //const [dataUserEliminar, setdataUserEliminar]=useState([])
    //const [fechaProcedimiento, setfechaProcedimiento]=useState('')
    const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
    const [errorMotivoCancelacion, seterrorMotivoCancelacion]=useState('')
    const [textAreaMotivo, settextAreaMotivo]=useState('')
    const handleCancelarClick=()=>{
        setmodalOnCancelarCirugia(false)
    }
    const handleOnchange=(e)=>{
        //console.log(e.target.value)
       
        if(e.target.value === "Sin Motivo"){
          seterrorMotivoCancelacion('Por favor elija un motivo de cancelación válido')
          settextAreaMotivo('')
        }else if(e.target.value === "Administrativo"){
          seterrorMotivoCancelacion('')
          settextAreaMotivo(' EL MOTIVO DE LA CANCELACIÓN FUE DE TIPO ADMINISTRATIVO')
        }else if(e.target.value === "Paciente"){
          seterrorMotivoCancelacion('')
          settextAreaMotivo(' EL MOTIVO DE LA CANCELACIÓN FUE DE TIPO PACIENTE')
        }else if(e.target.value === "Médico"){
          seterrorMotivoCancelacion('')
          settextAreaMotivo(' EL MOTIVO DE LA CANCELACIÓN FUE DE TIPO MÉDICO')
        }
      }
    const handleOnsubmitEliminar=(e)=>{
        e.preventDefault()
        console.log(user,'userr')
        if(errorMotivoCancelacion == ''){
            

            const updateProcir={
              "ProEmpCod":usuarioInfo.Empresa,
              "ProMCDpto": usuarioInfo.Sede,
              "ProCirCod": `${user.ProCirCod}`,
              "ProMotCan": e.target.observaciones.value,
              "PFcHrCnc": `${fechaActual()} ${HoraActual()}`,
              "ProEsta": "3"
          }
            console.log(updateProcir,'dataCancelarCirugia')
            postCancelarCirugia(updateProcir).then((res)=>{
                console.log(res.data,'hemos cancelado')
                passDataActualizarTabla(updateProcir)
                setmodalOnCancelarCirugia(false)
            })
          

          const updateHCCOM51={
            "HCProCir": `${user.ProCirCod}`,
            "HISTipDoc": user.MPTDoc,
            "HISCKEY": user.MPCedu,
            "HCPrcEst": "C",
            "HCObsCan":e.target.observaciones.value,
            "HCPrFhCaD":`${fechaActual()} ${HoraActual()}`
        }
        console.log(updateHCCOM51,'updateHCCOM51')
        postCambioDeEstadoCanceladoUpdateHCCOM51(updateHCCOM51).then((res)=>{
          console.log(res.data,'update hccom51')
        })

        const updateHCCOM5= {
          "HISCKEY": user.MPCedu,
          "HISTipDoc": user.MPTDoc,
          "HCPrStGr":"C",
          "HCProCir":`${user.ProCirCod}`
      }
      postEstadoCanceladoUpdateHCCOM5(updateHCCOM5).then((res)=>{
        console.log(res.data,'update hccom5')
      })

        }
    }

    useEffect(()=>{
        //console.log(user,'datauserrrrrr')
        seterrorMotivoCancelacion('Por favor elija un motivo de cancelación válido')
        // const dataCancelacion={
        //     ProEmpCod:usuarioInfo.Empresa,
        //     ProMCDpto:usuarioInfo.Sede,
        //     ProCirCod: user.ProCirCod
        // }
        // postDataCancelada(dataCancelacion).then((res)=>{
        //     //console.log(res.data,'data cancelada')
        // })
    },[])
  return (
    <div
        className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-slate-900 bg-opacity-25"
        id="exampleModalScrollable"
        tabIndex="-1"
        aria-labelledby="exampleModalScrollableLabel"
        aria-hidden="true"
      >
        <div className="sm:h-[calc(100%-3rem)] max-w-7xl my-6 mx-auto relative w-auto pointer-events-none ">
          <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
            <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
              <h5
                className="text-xl font-medium leading-normal text-white"
                id="exampleModalScrollableLabel"
              >
                Cancelación de cirugia
              </h5>
              <button
                type="button"
                onClick={handleCancelarClick}
                className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                X
              </button>
            </div>
            <div className="flex-auto overflow-y-auto relative">
            <form onSubmit={handleOnsubmitEliminar}>
              <div className="flex-auto overflow-y-auto relative p-4">
                
                  
                  <div className="flex flex-row py-2  text-left">
                    <div className="w-1/4  px-1 ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Empresa 
                      </label>
                      <input
                       defaultValue={user.ProEmpCod}
                        //autoComplete="off"
                        type="text"
                        disabled={true}
                        //defaultValue={dataUser.ProCirCod}
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                    <div className="w-1/4  px-1 ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Sede
                      </label>
                      <input
                      defaultValue={user.ProMCDpto}
                        autoComplete="off"
                        type="text"
                        disabled={true}
                        //defaultValue={dataUser.MPCedu}
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                    <div className="w-1/4  px-1 ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        N° Cirugía
                      </label>
                      <input
                      defaultValue={user.ProCirCod}
                        autoComplete="off"
                        type="text"
                        disabled={true}
                        //defaultValue={dataUser.MPTDoc}
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                    <div className="w-1/4  px-1 ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Quirófano
                      </label>
                      <input
                      defaultValue={user.ConsDet}
                        autoComplete="off"
                        type="text"
                        disabled={true}
                        //defaultValue={dataUser.MPNOMC}
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div className="flex flex-row py-2  text-left">
                    <div className="w-1/4  px-1 ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Fecha Cirugía
                      </label>
                      <input
                        defaultValue={user.ProFec.split(' ')[0]}
                        autoComplete="off"
                        type="date"
                        disabled={true}
                        //defaultValue={dataUser.ProCirCod}
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                    <div className="w-1/4  px-1 ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Hora Inicial
                      </label>
                      <input
                      defaultValue={user.ProHorI}
                        autoComplete="off"
                        type="time"
                        disabled={true}
                        //defaultValue={dataUser.MPCedu}
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                    <div className="w-1/4  px-1 ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Hora Final
                      </label>
                      <input
                        defaultValue={user.ProHorF}
                        autoComplete="off"
                        type="time"
                        disabled={true}
                        //defaultValue={dataUser.MPTDoc}
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                    <div className="w-1/4  px-1 ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Paciente
                      </label>
                      <input
                      defaultValue={user.MPNOMC}
                      name='pacienteCedula'
                        autoComplete="off"
                        type="text"
                        disabled={true}
                        //defaultValue={dataUser.MPNOMC}
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                  </div>
                
                <h5
                  className="text-xl font-medium leading-normal text-gray-800 text-center pt-5"
                  id="exampleModalScrollableLabel"
                >
                  Motivo de Cancelación
                </h5>
                <div className="text-left pt-5">
                  <div className="w-1/4  px-4 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      
                    </label>
                    <div className="">
                      <select
                        //defaultValue={dataDetalles.ViaCod}
                        onChange={handleOnchange}
                        className="form-select block  w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                        aria-label="Default select example"
                      >
                        <option value="Sin Motivo">Sin Motivo</option>
                        <option value="Administrativo">Administrativo </option>
                        <option value="Paciente">Paciente</option>
                        <option value="Médico">Médico</option>
                      </select>
                    </div>
                    
                  </div>
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                        {errorMotivoCancelacion}
                    </label>
                  <div className="w-3/4 px-4 pt-2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Observaciones
                      </label>
                    <textarea
                      autoComplete="off" 
                      defaultValue={textAreaMotivo} 
                      name='observaciones'                    
                      className="form-control block w-full px-3 py-1.5 text-base font-normal  text-gray-700  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300 rounded
                            transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      id="exampleFormControlTextarea1"
                      rows="2"
                      placeholder=""
                    ></textarea>
                  </div>
                </div>

                
              </div>
            
            <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
              <button
                type="button"
                onClick={handleCancelarClick}
                className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
                data-bs-dismiss="modal"
              >
                Cerrar
              </button>
              <button type="submit"
                className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
                Cancelar
              </button>
            </div>
            </form>
            </div>
          </div>
        </div>
      </div>
  )
}

export default ConfirmarEstadoCancelacion